<template>
  <div class="external-component">
  </div>
</template>

<script>
import * as topojson from 'topojson-client'
import topojsonmap from './topojsonmap.json'
import {store} from './wuhanData'

const d3 = Object.assign({}, require('d3-request'), require('d3-selection'), require('d3-format'), require('d3-geo'), require('d3-scale'), require('d3-array'), require('d3-transition'), require('d3-ease'), require('d3-axis'))

export default {
  props: ['attributes'],
  methods: {
    initCode (data) {
      // const deaths = new Map(data.filter(d => d.country !== 'China').map(d => [d.country || d.province, d.deaths]))
      // const confirmed = new Map(data.filter(d => d.country !== 'China').map(d => [d.country || d.province, d.cases]))
      const deaths = new Map(data.map(d => [d.country || d.province, d.deaths]))
      const confirmed = new Map(data.map(d => [d.country || d.province, d.cases]))
      const confirmedAsia = new Map(data.filter(d => d.region === 'Asia').map(d => [d.country, d.cases]))

      const legendCircles = [['Confirmed', '#D4883D'], ['Deaths', '#952370']]

      const format = d3.format(',.0f')

      const projection = d3.geoAzimuthalEqualArea().rotate([-105, -30]).scale(600)

      const path = d3.geoPath().projection(projection)

      const radius = d3.scaleSqrt([0, d3.max(data.filter(d => d.region === 'Asia'), d => d.cases)], [0, 100])

      // const svg = d3.create("svg")
      // .attr("viewBox", [0, 0, 975, 610]);

      /*
        I believe the only missing bit here is the selection of the div and associated measures, width and height — because observable already has that data from the cell as globals.
        */

      var width = this.$el.clientWidth

      d3.select(this.$el).append('svg')
          .attr('viewBox', [0, 0, 975, 610])
          .attr('id', 'mapsvg')
          .attr('height', '150vh')
          .attr('width', '100%')

      const svg = d3.select(this.$el).select('#mapsvg')

      var tooltipRect = {}
      var tooltip = {}

      // const height = this.$el.clientHeight
      var othersLegendCoord = []
      var othersLegendCoord2 = []

      if (width <= 400) {
        // svg.attr('transform', 'translate(0, 0) scale(2)')
        svg.style('transform', 'translate(30px, 0) scale(1.4)')
      }

      svg.append('path')
          .datum(topojson.feature(topojsonmap, topojsonmap.objects.asia_with_china_prov))
          .attr('fill', '#f3f3f3')
          .attr('d', path)

      const countryBoundaries = {
        type: 'GeometryCollection',
        geometries: topojsonmap.objects.asia_with_china_prov.geometries.filter(d => d.properties.CODE.length <= 3)
      }

      const provBoundaries = {
        type: 'GeometryCollection',
        geometries: topojsonmap.objects.asia_with_china_prov.geometries.filter(d => d.properties.CODE.length > 3)
      }

      svg.append('path')
          .datum(topojson.mesh(topojsonmap, countryBoundaries, (a, b) => a !== b))
          .attr('fill', 'none')
          .attr('stroke', '#bdbdbd')
          .attr('stroke-linejoin', 'round')
          .attr('d', path)

      svg.append('path')
          .datum(topojson.mesh(topojsonmap, provBoundaries, (a, b) => a !== b))
          .attr('fill', 'none')
          // .attr('stroke', '#dfdfdf')
          .attr('stroke', 'none')
          .attr('stroke-linejoin', 'round')
          .attr('d', path)

      svg.append('g')
          .attr('class', 'confirmed')
          .attr('stroke', '#D4883D')
          .attr('fill', 'transparent')
          .attr('stroke-width', 1)
          .selectAll('circle')
          .data(topojson.feature(topojsonmap, topojsonmap.objects.asia_with_china_prov).features
          .map(d => (d.value = confirmed.get(d.properties.NAME), d))
          .sort((a, b) => b.value - a.value))
          .join('circle')
          .attr('transform', d => {
            const coord = path.centroid(d)
            if (isNaN(coord[0])) return ''
            if (d.properties.NAME === 'Sri Lanka') {
              othersLegendCoord = coord
            }
            if (d.properties.NAME === 'Philippines') {
              othersLegendCoord2 = coord
            }
            if (d.properties.NAME.includes('Malaysia')) {
              return `translate(${coord[0] - 80}, ${coord[1]})`
            } else if (d.properties.NAME.includes('Vietnam')) {
              return `translate(${coord[0] + 5}, ${coord[1] - 5})`
            }
            return `translate(${coord})`
          })
          .attr('r', d => radius(d.value))
          .on('mouseover', function (d) {
            const coord = path.centroid(d)
            tooltip.attr('transform', `translate(${coord[0]}, ${coord[1] - 10})`)
              .style('transform', `translate(${coord[0]}px, ${coord[1] - 10}px)`)
              .text(d.properties.NAME + ' ' + format(d.value))
              .transition()
              .duration(200)
              .ease(d3.easeQuad)
              .style('opacity', 1)

            const bbox = tooltip.node().getBBox()
            tooltipRect.style('transform', `translate(${coord[0]}px, ${coord[1] - 10}px)`)
              .attr('x', bbox.x - 5)
              .attr('y', bbox.y)
              .attr('width', bbox.width + 10)
              .attr('height', bbox.height)
              .transition()
              .duration(100)
              .ease(d3.easeQuad)
              .style('opacity', 1)
          })
          .on('mouseout', function (d) {
            // tooltip.transition()
            //  .duration(500)
            //  .style('opacity', 0)
            // tooltipRect.transition()
            //  .duration(500)
            //  .style('opacity', 0)
          })
          .on('click', function (d) {
            const coord = path.centroid(d)
            tooltip.attr('transform', `translate(${coord[0]}, ${coord[1] - 10})`)
              .style('transform', `translate(${coord[0]}px, ${coord[1] - 10}px)`)
              .text(d.properties.NAME + ' ' + d.value)
              .transition()
              .duration(200)
              .ease(d3.easeQuad)
              .style('opacity', 1)

            const bbox = tooltip.node().getBBox()
            tooltipRect.style('transform', `translate(${coord[0]}px, ${coord[1] - 10}px)`)
              .attr('x', bbox.x - 5)
              .attr('y', bbox.y)
              .attr('width', bbox.width + 10)
              .attr('height', bbox.height)
              .transition()
              .duration(100)
              .ease(d3.easeQuad)
              .style('opacity', 1)
          })

      svg.append('g')
          .attr('class', 'deaths')
          .attr('fill', '#952370')
          .attr('fill-opacity', '0.8')
          .attr('stroke', 'none')
          .selectAll('circle')
          .data(topojson.feature(topojsonmap, topojsonmap.objects.asia_with_china_prov).features
          .map(d => (d.value = deaths.get(d.properties.NAME), d))
          .sort((a, b) => b.value - a.value))
          .join('circle')
          .attr('transform', d => {
            const coord = path.centroid(d)
            if (isNaN(coord[0])) return ''
            if (d.properties.NAME.includes('Malaysia')) {
              return `translate(${coord[0] - 80}, ${coord[1]})`
            }
            return `translate(${coord})`
          })
          .attr('r', d => radius(d.value))
          .on('mouseover', function (d) {
            const coord = path.centroid(d)
            tooltip.attr('transform', `translate(${coord[0]}, ${coord[1] - 10})`)
              .style('transform', `translate(${coord[0]}px, ${coord[1] - 10}px)`)
              .text(d.properties.NAME + ' ' + d.value)
              .transition()
              .duration(200)
              .ease(d3.easeQuad)
              .style('opacity', 1)

            const bbox = tooltip.node().getBBox()
            tooltipRect.style('transform', `translate(${coord[0]}px, ${coord[1] - 10}px)`)
              .attr('x', bbox.x - 5)
              .attr('y', bbox.y)
              .attr('width', bbox.width + 10)
              .attr('height', bbox.height)
              .transition()
              .duration(100)
              .ease(d3.easeQuad)
              .style('opacity', 1)
          })
          .on('mouseout', function (d) {
            // tooltip.transition()
            //  .duration(500)
            //  .style('opacity', 0)
            // tooltipRect.transition()
            //  .duration(500)
            //  .style('opacity', 0)
          })
          .on('click', function (d) {
            const coord = path.centroid(d)
            tooltip.attr('transform', `translate(${coord[0]}, ${coord[1] - 10})`)
              .style('transform', `translate(${coord[0]}px, ${coord[1] - 10}px)`)
              .text(d.properties.NAME + ' ' + d.value)
              .transition()
              .duration(200)
              .ease(d3.easeQuad)
              .style('opacity', 1)

            const bbox = tooltip.node().getBBox()
            tooltipRect.style('transform', `translate(${coord[0]}px, ${coord[1] - 10}px)`)
              .attr('x', bbox.x - 5)
              .attr('y', bbox.y)
              .attr('width', bbox.width + 10)
              .attr('height', bbox.height)
              .transition()
              .duration(100)
              .ease(d3.easeQuad)
              .style('opacity', 1)
          })

      svg.append('g')
          .selectAll('text')
          .data(topojson.feature(topojsonmap, topojsonmap.objects.asia_with_china_prov).features
          .map(d => (d.value = confirmedAsia.get(d.properties.NAME), d))
          .filter(d => d.value > 0)
          .sort((a, b) => b.value - a.value))
          .join('text')
          .attr('transform', d => {
            const coord = path.centroid(d)
            if (d.properties.NAME.includes('Macau')) {
              return `translate(${coord[0]}, ${coord[1] + 25})`
            } else if (d.properties.NAME.includes('Malaysia')) {
              return `translate(${coord[0] - 80}, ${coord[1]})`
            } else if (d.properties.NAME.includes('Thailand')) {
              return `translate(${coord[0]}, ${coord[1] + 5})`
            } else if (d.properties.NAME.includes('India')) {
              return `translate(${coord[0]}, ${coord[1] - 10})`
            } else if (d.properties.NAME.includes('Japan')) {
              return `translate(${coord[0] - 30}, ${coord[1]})`
            } else if (d.properties.NAME.includes('Timor-Leste')) {
              return `translate(${coord[0] - 30}, ${coord[1]})`
            } else {
              return `translate(${path.centroid(d)})`
            }
          })
          .attr('y', -10)
          .attr('text-anchor', 'middle')
          .text(d => {
            if (width <= 420) {
              return `${d.properties.CODE} `
            } else {
              if (d.properties.NAME.includes('S.A.R.')) {
                return `${d.properties.NAME.replace('S.A.R.', '')} `
              }
              return `${d.properties.NAME} `
            }
          })
          .append('tspan')
          .text(d => `${format(d.value)}`)

      svg.append('g')
          .attr('class', 'legendCircles')
          .selectAll('circle')
          .data(legendCircles)
          .join('circle')
          .attr('fill', d => d[0] === 'Deaths' ? d[1] : 'none')
          .attr('fill-opacity', '0.8')
          .attr('stroke', d => d[0] === 'Deaths' ? 'none' : d[1])
          .attr('stroke-width', 1)
          .attr('transform', (d, i) => {
            if (width <= 400) {
              return `translate(150, ${30 - 2 + (i * 22)})`
            }
            return `translate(20, ${30 - 2 + (i * 22)})`
          })
          .attr('r', d => 3)

      svg.append('g')
          .selectAll('text')
          .data(legendCircles)
          .join('text')
          .attr('transform', (d, i) => {
            if (width <= 400) {
              return `translate(150, ${30 + (i * 22)})`
            }
            return `translate(20, ${30 + (i * 22)})`
          })
          .attr('y', width <= 400 ? 4 : 2)
          .attr('x', 12)
          .text(d => `${d[0]}`)

      tooltipRect = svg.append('rect')
          .attr('class', 'tooltip-rect')
          .style('opacity', 0)

      tooltip = svg.append('text')
          .attr('class', 'tooltip')
          .style('opacity', 0)
      // })
    }
  },
  mounted () {
    this.$watch(() => store.rawData, function (data) {
      if (data) this.initCode(data)
    }, {immediate: true})
  }
}
</script>
<style lang="scss">
.external-component {
  padding-bottom: 60px;
  #mapsvg {
    max-height: 400px;
    @include breakpoint($d_medium) {
      max-height: 900px;
    }
  }
  text {
    font-family: $font-CuratorRegular;
    font-size: 20px;
    @include breakpoint($d_medium) {
      font-size: 12px;
    }
    tspan {
      font-family: $font-CuratorBold;
    }
  }
  .tooltip-rect {
    fill: #fff;
    fill-opacity: 0.9;
    rx: 5;
  }
  .tooltip {
    font-family: $font-CuratorRegular;
    font-size: 20px;
    @include breakpoint($d_medium) {
      font-size: 12px;
    }
    fill: #333;
  }
}
</style>
